import { __assign, __rest } from "tslib";
import React from 'react';
import { Box, Flex, Text, Heading, CloseButton } from '@marvelapp/ui';
import { ArtboardIcon, GroupIcon, ImageIcon, ShapeIcon, TextIcon, } from './icons';
export default function PanelHeader(_a) {
    var title = _a.title, layerName = _a.layerName, layerType = _a.layerType, onClose = _a.onClose;
    var layerDetails = getLayerDetails({ layerType: layerType });
    return (React.createElement(Header, null,
        React.createElement(Flex, { alignItems: "center" },
            React.createElement(Icon, null, layerDetails.icon),
            React.createElement(Box, null,
                React.createElement(Heading, { fontSize: 2, fontWeight: 500, marginBottom: 1 }, title || layerName),
                React.createElement(Text, { fontSize: 12 }, layerDetails.subtext))),
        React.createElement(Box, null,
            React.createElement(CloseButton, { height: 30, onClick: onClose, width: 30 }))));
}
function Header(_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(Flex, __assign({ alignItems: "center", bg: "white", borderBottom: "1px solid", borderColor: "smoke", justifyContent: "space-between", padding: 3 }, rest), children));
}
function Icon(_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(Flex, __assign({ alignItems: "center", border: "1px solid", borderColor: "smoke", borderRadius: 2, height: 42, justifyContent: "center", marginRight: 3, width: 42 }, rest), children));
}
function getLayerDetails(_a) {
    var layerType = _a.layerType;
    if (layerType === 'group') {
        return {
            icon: React.createElement(GroupIcon, null),
            subtext: 'Group of layers',
        };
    }
    if (layerType === 'text') {
        return {
            icon: React.createElement(TextIcon, null),
            subtext: 'Text layer',
        };
    }
    if (layerType === 'shape') {
        return {
            icon: React.createElement(ShapeIcon, null),
            subtext: 'Shape layer',
        };
    }
    if (layerType === 'raster') {
        return {
            icon: React.createElement(ImageIcon, null),
            subtext: 'Image layer',
        };
    }
    return {
        icon: React.createElement(ArtboardIcon, null),
        subtext: 'Artboard/Screen',
    };
}
